/* Publish by EComposer at 2026-09-30 10:17:47*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zpduf2996bg"]=  window.__ectimmers["ecom-zpduf2996bg"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-zpduf2996bg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zpduf2996bg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r1jhciwvec').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r1jhciwvec', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k6jbjknk31').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k6jbjknk31', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i68sm7825v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i68sm7825v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z05nmo3rh0q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z05nmo3rh0q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-reacz6208hi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-reacz6208hi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tlsegngo1s9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tlsegngo1s9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ravdrqgx06').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ravdrqgx06', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xkpievcd0t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xkpievcd0t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q9wm6l2phwr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q9wm6l2phwr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c0azxbwrieh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c0azxbwrieh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-888b0yn5u86').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-888b0yn5u86', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c1c7di3iqg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c1c7di3iqg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fdysqp08bhf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fdysqp08bhf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u3zlqing4w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u3zlqing4w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mjc81du1lca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mjc81du1lca', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9e6xpw058mq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9e6xpw058mq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fnd65o2sdc9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fnd65o2sdc9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6x0n77pua4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6x0n77pua4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a69snv4725b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a69snv4725b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4sjbs3ewd3w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4sjbs3ewd3w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pm2qkl4tle9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pm2qkl4tle9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e9z73qhn29d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e9z73qhn29d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bzoxxfi9gzg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bzoxxfi9gzg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tj19iraxb5o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tj19iraxb5o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-561t1imwkdr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-561t1imwkdr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mb1546cdhv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mb1546cdhv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-npqi06tubj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-npqi06tubj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2hkmll92sjj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2hkmll92sjj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nxz23i0mlab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nxz23i0mlab', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ee3f251wx84').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ee3f251wx84', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uy4htiuwryh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uy4htiuwryh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-35rxjiwxklw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-35rxjiwxklw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cv3zei6e32l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cv3zei6e32l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53e31uzsotj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53e31uzsotj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7iw833q66vn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7iw833q66vn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l8998l5zehs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l8998l5zehs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m81n0u7ubfp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m81n0u7ubfp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9djhc7pk0cn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9djhc7pk0cn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pnccf1z75yl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pnccf1z75yl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5nyo5izu0f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5nyo5izu0f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l2jyy56ayw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l2jyy56ayw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-spvrkgbfjn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-spvrkgbfjn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dn8vae73cba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dn8vae73cba', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ab32xegv4m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ab32xegv4m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4bi44gn33r3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4bi44gn33r3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ck1ma4z0ww').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ck1ma4z0ww', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e8ewxuvf3ew').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e8ewxuvf3ew', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-95gltj1twj5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-95gltj1twj5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8uhpqwz3i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8uhpqwz3i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ifqam1th4y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ifqam1th4y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g4bxvjbng79').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g4bxvjbng79', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yyfx258is8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yyfx258is8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lbwegpqi4p9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lbwegpqi4p9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kp3dvfom0qm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kp3dvfom0qm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xt54f2xbtrh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xt54f2xbtrh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4h253ijo0x6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4h253ijo0x6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qo8hsebv2w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qo8hsebv2w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8rdmup03kup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8rdmup03kup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k2vkn9085qp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k2vkn9085qp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-13v1mxg4lkk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-13v1mxg4lkk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hke1votgw08').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hke1votgw08', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ephmttsigs"]=  window.__ectimmers["ecom-ephmttsigs"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-ephmttsigs"]["t433emeye"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ephmttsigs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ephmttsigs', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e72dmlgygih"]=  window.__ectimmers["ecom-e72dmlgygih"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,n=($=this.settings.disable_auto_close__tablet)!=null?$:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(L){return o&&L<768||n&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let U=null;function G(oe){U||(U=oe);const se=Math.min((oe-U)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*Y),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,U=Z.querySelector(":scope > .ecom-accordion__body");!r&&U&&U.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");U&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{U.style.height=U.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,de=Y.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),te=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=_(se);if(q)J?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&te&&te.classList.add("ecom-effect-accodion"),b(te)}window.dispatchEvent(new window.Event("renderScroll"));const X=this,ue=s||se>1024;function K(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(X)&&k(X)}if(ue&&!r){let fe;const Te=function(ze){ze.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},600)}else requestAnimationFrame(()=>{setTimeout(K,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-e72dmlgygih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e72dmlgygih', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}